export default {
  // 毫秒数转换时分秒
  time_timeStamp_to_hms: (time = 0, hms = 'hms') => {
    let oHour = parseInt(time / 1000 / 60 / 60)
    let oMin = parseInt(time / 1000 / 60 % 60)
    let oSec = parseInt(time / 1000 % 60)
    let oTime = '' // 最后拼接时间

    let arr = [oHour, oMin, oSec]
    arr.forEach((x, i) => {
      x < 10 ? (arr[i] = '0' + x) : ''
    })
    switch (hms) {
      case 'h':
        oTime = arr[0]
        break
      case 'hm':
        oTime = arr[0] + ':' + arr[1]
        break
      case 'hms':
        oTime = arr[0] + ':' + arr[1] + ':' + arr[2]
        break
    }
    return oTime
  },
  // 毫秒数转换时
  time_timeStamp_to_h: (time = 0, n = 1) => (time / 1000 / 60 / 60).toFixed(n),
  // 毫秒数转换分
  time_timeStamp_to_m: (time = 0, n = 1) => (time / 1000 / 60).toFixed(n),
  // 毫秒数转换秒
  time_timeStamp_to_s: (time = 0, n = 1) => (time / 1000).toFixed(n),

  // 获取当前时间的年份
  time_get_year: () => new Date().getFullYear(),
  // 获取当前时间的月份 fillFlag 布尔值 是否补0 默认true
  time_get_month: (fillFlag = true) => {
    const mon = new Date().getMonth() + 1
    return fillFlag && mon < 10 ? `0${mon}` : mon
  },
  // 获取当前时间的号数 fillFlag 布尔值 是否补0 默认true
  time_get_day: (fillFlag = true) => {
    const day = new Date().getDate()
    const dayRe = day
    if (fillFlag) day < 10 ? `0${day}` : day
    return dayRe
  },
  // 获取当前时间的时间戳
  time_get_timeStamp: () => new Date().getTime(),
  // 获取星期几
  time_get_weekDay: () => (new Date().getDay() ? new Date().getDay() : 7),
  // 获取指定月份的天数
  time_get_monthNum: (year, month) => new Date(year, month, 0).getDate(),
  // Date对象 获取n个月后的 Date对象
  time_get_dateObj_after_n_month: (n, date = new Date()) => {
    date.setMonth(date.getMonth() + n)
    return date
  },
  // 年月日 获取1个月后的 年月日
  time_get_ymd_after_1_month: date => {
    var arr = date.split('-')
    var year = arr[0] // 获取当前日期的年份
    var month = arr[1] // 获取当前日期的月份
    var day = arr[2] // 获取当前日期的日
    var days = new Date(year, month, 0)
    days = days.getDate() // 获取当前日期中的月的天数
    var year2 = year
    var month2 = parseInt(month) + 1
    if (month2 == 13) {
      year2 = parseInt(year2) + 1
      month2 = 1
    }
    var day2 = day
    var days2 = new Date(year2, month2, 0)
    days2 = days2.getDate()
    if (day2 > days2) {
      day2 = days2
    }
    if (month2 < 10) {
      month2 = '0' + month2
    }
    var t2 = year2 + '-' + month2 + '-' + day2
    return t2
  },
  // 年月日 获取n个月后的 年月日（默认1月）
  time_get_ymd_after_n_month: (date, n = 1) => {
    var arr = date.split('-')
    var year = arr[0] // 获取当前日期的年份
    var month = arr[1] // 获取当前日期的月份
    var day = arr[2] // 获取当前日期的日
    var days = new Date(year, month, 0)
    days = days.getDate() // 获取当前日期中的月的天数
    var year2 = year
    var month2 = parseInt(month) + n
    let moreYear = Math.floor(month2 / 12)
    let yuYear = month2 % 12 || 12
    if (moreYear > 0) {
      if (yuYear === 12) {
        moreYear--
      }
      year2 = parseInt(year2) + moreYear
      month2 = yuYear
    }
    var day2 = day
    var days2 = new Date(year2, month2, 0)
    days2 = days2.getDate()
    if (day2 > days2) {
      day2 = days2
    }
    if (month2 < 10) {
      month2 = '0' + month2
    }
    var t2 = year2 + '-' + month2 + '-' + day2
    return t2
  },
  // 年月日 获取n个年后的 年月日（默认1年）
  time_get_ymd_after_n_year: (date, n = 1) => {
    var arr = date.split('-')
    var year = Number(arr[0]) // 获取当前日期的年份
    var month = Number(arr[1]) // 获取当前日期的月份
    var day = Number(arr[2]) // 获取当前日期的日
    var days = new Date(year, month, 0)
    days = days.getDate() // 获取当前日期中的月的天数
    var year2 = parseInt(year) + n
    var month2 = month
    var day2 = day
    var days2 = new Date(year2, month2, 0)
    days2 = days2.getDate()
    if (day2 > days2) {
      day2 = days2
    }
    if (month2 < 10) {
      month2 = '0' + month2
    }
    var t2 = year2 + '-' + month2 + '-' + day2
    return t2
  },
  // 获取指定日期（默认当前）n天后的Date对象
  time_get_dateObj_after_n_day: (n, date = new Date()) => {
    let target = new Date(date)
    target.setDate(target.getDate() + n)
    return target
  },

  // 时间 => 时间戳
  time_parse_timeStamp: (date = new Date()) => {
    if (typeof date === 'string') {
      date = new Date(date.replace(/-/g, '/'))
    }
    return date.getTime()
  },
  // 时间 => Date对象
  time_parse_dateObj: date => {
    if (typeof date === 'string') {
      date = date.replace(/-/g, '/')
    }
    return new Date(date)
  },
  /** 时间 => 年月日(时分秒)
   * @param {Number|Date} date
   * @param {String} type 格式类型 '-' '/'
   * @param {String} hms 可选,格式类型 'h' 'hm' 'hms'
   * @returns {String}
   */
  time_parse_ymd: (date = new Date(), type = '-', hms) => {
    if (typeof date === 'number') date = new Date(date)
    const oYear = date.getFullYear()
    let oMonth = date.getMonth() + 1
    let oDay = date.getDate()
    let oHour = date.getHours()
    let oMin = date.getMinutes()
    let oSec = date.getSeconds()
    let oTime // 最后拼接时间

    let arr = [oMonth, oDay, oHour, oMin, oSec]
    arr.forEach((x, i) => {
      x < 10 ? (arr[i] = '0' + x) : ''
    })
    oTime = oYear + type + arr[0] + type + arr[1]
    switch (hms) {
      case 'h':
        oTime += ' ' + arr[2]
        break
      case 'hm':
        oTime += ' ' + arr[2] + ':' + arr[3]
        break
      case 'hms':
        oTime += ' ' + arr[2] + ':' + arr[3] + ':' + arr[4]
        break
    }
    return oTime
  },
  /** 时间 => 时分秒
   * @param {Number|Date} date
   * @param {String} hms 可选,格式类型 'h' 'hm' 'hms'
   * @returns {String}
   */
  time_parse_hms: (date = new Date(), hms = 'hms') => {
    if (typeof date === 'number') date = new Date(date)
    let oHour = date.getHours()
    let oMin = date.getMinutes()
    let oSec = date.getSeconds()
    let oTime = '' // 最后拼接时间

    let arr = [oHour, oMin, oSec]
    arr.forEach((x, i) => {
      x < 10 ? (arr[i] = '0' + x) : ''
    })
    switch (hms) {
      case 'h':
        oTime = arr[0]
        break
      case 'hm':
        oTime = arr[0] + ':' + arr[1]
        break
      case 'hms':
        oTime = arr[0] + ':' + arr[1] + ':' + arr[2]
        break
    }
    return oTime
  },
  /** 时间转换
   * @param {(Object|String|number)} time new Date()|'2000-01-01 00:00'|946656000000
   * @param {String} option '{y}-{m}-{d} {h}:{i}:{s} 星期{a}'
   * @returns {String | null}
   */
  time_parse: (time, option) => {
    if (arguments.length === 0 || !time) {
      return null
    }
    const format = option || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (typeof time === 'string') {
        if (/^[0-9]+$/.test(time)) {
          // support "1548221490638"
          time = parseInt(time)
        } else {
          // support safari
          // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
          time = time.replace(new RegExp(/-/gm), '/')
        }
      }

      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay(),
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
      const value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      return value.toString().padStart(2, '0')
    })
    return time_str
  },
  /** 时间转换 用于评论时间等，如刚刚，2分钟前
   * @param {number|string} time
   * @param {string} option
   * @returns {string}
   */
  time_format: (time, option) => {
    if (('' + time).length === 10) {
      time = parseInt(time) * 1000
    } else {
      time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
      return '刚刚'
    } else if (diff < 3600) {
      // less 1 hour
      return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
      return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
      return '1天前'
    }
    if (option) {
      return time_parse(time, option)
    } else {
      return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
    }
  },
  // ymd时间比较
  time_compare: (t1, t2) => new Date(t1.replace(/-/g, '/')).getTime() < new Date(t2.replace(/-/g, '/')).getTime(),
}
